<!-- TOP ベネ通販タブ -->
<template>
  <div class="c-shop-search c-card__content">
    <div class="c-card__inner">
      <p class="c-shop-search__caution">
        <span>カテゴリ・ポイント・キーワードのいずれかをご入力ください</span>
      </p>
      <div class="c-shop-search__category c-shop-search__param">
        <div class="c-shop-search__param__label">カテゴリ</div>
        <div class="c-select">
          <select
            v-model="form.catMidClassCd"
            class="c-select__control"
            :disabled="middleCategoryList.length === 0"
            @change="onChangeMidCat($event)"
          >
            <option selected value="" class="default">カテゴリを選択</option>
            <option
              v-for="(middle, i) in middleCategoryList"
              :key="`middle-${i}`"
              :value="middle.catClassCd"
            >
              {{ middle.name }}
            </option>
          </select>
        </div>
        <div class="c-select">
          <select
            v-model="form.catSmlClassCd"
            class="c-select__control"
            :disabled="form.catMidClassCd === '' || !smallCategory"
          >
            <option selected value="" class="default">詳細カテゴリ</option>
            <option
              v-for="(small, i) in smallCategory"
              :key="`small-${i}`"
              :value="small.catClassCd"
            >
              {{ small.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="c-shop-search__price c-shop-search__param">
        <div class="c-shop-search__param__label">ポイント</div>
        <div class="c-shop-search__input-wrapper">
          <div class="c-input">
            <input
              v-model="form.priceFrom"
              type="text"
              inputmode="numeric"
              maxlength="10"
              :class="{
                'c-input__background': true,
                'c-input__background--error': formErrorPriceFrom
              }"
              @input="toNumFormatPriceFrom"
            />
          </div>
          <span class="c-shop-search__unit" data-translate-skip>{{ pointName }}</span>
        </div>

        <span class="c-shop-search__unit">〜</span>

        <div class="c-shop-search__input-wrapper">
          <div class="c-input">
            <input
              v-model="form.priceTo"
              type="text"
              inputmode="numeric"
              maxlength="10"
              :class="{
                'c-input__background': true,
                'c-input__background--error': formErrorPriceTo
              }"
              @input="toNumFormatPriceTo"
            />
          </div>
          <span class="c-shop-search__unit" data-translate-skip>{{ pointName }}</span>
        </div>
      </div>
      <div class="c-shop-search__keyword p-toppage__search__main__row">
        <div class="p-toppage__search__main__keyword">
          <FormsKeywordSearch
            :placeholder="'商品名・ブランド・メニューNoなどを入力'"
            :background="true"
            @input="inputKeyword"
            @on-search="onSearch()"
          />
        </div>
        <div v-if="formError" class="p-toppage__search__main__input--error">
          <span class="c-shop-search__error-icon">
            <IconAlert name="alert" />
          </span>
          <span class="c-shop-search__error-message">
            {{ formError }}
          </span>
        </div>
      </div>
      <div class="p-toppage__search__main__row">
        <div class="p-toppage__search__main__keyword">
          <div class="c-shop-search__checkbox-wrap">
            <!-- 現在のポイント内で探す -->
            <AppCheckbox
              label="現在のポイント内で探す"
              :isChecked="form.chkCurrentPoint"
              class="c-shop-search__checkbox"
              @clicked="toggleChkCurrentPoint"
            />
            <!-- 販売期間外商品も表示する -->
            <AppCheckbox
              label="販売期間外商品も表示する"
              :isChecked="form.checked.includes('without_sales_period')"
              class="c-shop-search__checkbox"
              @clicked="setCheckboxValue('without_sales_period')"
            />
            <!-- 在庫なし商品も表示する -->
            <AppCheckbox
              label="在庫なし商品も表示する"
              :isChecked="form.checked.includes('stock_nothing')"
              class="c-shop-search__checkbox"
              @clicked="setCheckboxValue('stock_nothing')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import FormsKeywordSearch from "@/general/components/pages/KeywordSearch.vue";
import { getLargeCategories } from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import AppCheckbox from "@/common/components/atoms/AppCheckbox.vue";
import { POINT_MAX } from "@/general/config/constants";

export default {
  name: "ShopBeneOnlineShop",
  components: {
    FormsKeywordSearch,
    IconAlert,
    AppCheckbox
  },
  props: {
    /** 親（CmsHeaderSearch）で取得した使用可能ポイント */
    icPoints: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      /**
       * カテゴリ一覧
       */
      categories: [],
      form: {
        keyword: "",
        /**
         * 大カテゴリ
         */
        catLrgClassCd: "115",
        /**
         * 選択中の中カテゴリ
         */
        catMidClassCd: "",
        /**
         * 選択中の小カテゴリ
         */
        catSmlClassCd: "",
        /**
         * 価格帯FROM
         */
        priceFrom: "",
        /**
         * 価格帯TO
         */
        priceTo: "",
        // /**
        //  * 割引率FROM
        //  */
        // discountFrom: "",
        // /**
        //  * 割引率TO
        //  */
        // discountTo: ""
        chkCurrentPoint: false,
        /**
         * 使える商品チェック
         */
         checked: [],
      },
      /**
       * 入力エラー
       */
      formError: "",
      formErrorPriceFrom: false,
      formErrorPriceTo: false,
      //   formErrorDiscountFrom: false,
      //   formErrorDiscountTo: false
    };
  },
  computed: {
    /**
     * 中カテゴリ一覧
     * @returns {Array<object?>}
     */
    middleCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            item.level === 2 &&
            item.catLrgClassCd === this.form.catLrgClassCd
          ) {
            return item;
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /**
     * 小カテゴリ一覧
     * @returns {Array<object?>}
     */
    smallCategory() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 3 &&
            item.catLrgClassCd === this.form.catLrgClassCd &&
            item.catMidClassCd === this.form.catMidClassCd
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /**
     * ポイント名。指定がなければ"Point"
     * @return {string}
     */
    pointName() {
      return this.$store.state.commons.userInfo?.point_name || "Point";
    }
  },
  async mounted() {
    this.getCategories();
  },
  methods: {
    /**
     * 現在のポイント内で探すがクリックされたらチェック状態を切り替える
     */
    toggleChkCurrentPoint() {
      this.form.chkCurrentPoint = !this.form.chkCurrentPoint;
    },

    /**
     * appcheckboxがクリックされたら値を切り替える
     * @param {string} type
     */
    setCheckboxValue(type) {
      this.form.checked.includes(type)
        ? this.form.checked.splice(this.form.checked.indexOf(type), 1)
        : this.form.checked.push(type)
    },
    /**
     * カテゴリー一覧の取得
     */
    async getCategories() {
      //   const res = await this.$repositories("shop").getLargeCategories();
      //   if (res) {
      //     this.categories = res.data.categories || [];
      //   }

      const res = await getLargeCategories();
      if (res) {
        this.categories = res.categories || [];
      }
    },
    /**
     * 中カテゴリ変更イベント
     * @param {*} event
     */
    onChangeMidCat(event) {
      if (event.target.value === "") {
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catMidClassCd = event.target.value;
        this.form.catSmlClassCd = "";
      }
    },
    /**
     * キーワード変更イベント
     * @param {*} value
     */
    inputKeyword(value) {
      this.form.keyword = value;
    },
    /**
     * 正数値かのチェック
     */
    isNumber(num) {
      if (num) {
        const number = Number(num);
        if (number >= 0) {
          if (!Number.isInteger(number)) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    /**
     * 入力チェック
     */
    validate() {
      this.formErrorPriceFrom = false;
      this.formErrorPriceTo = false;
      //   this.formErrorDiscountFrom = false;
      //   this.formErrorDiscountTo = false;
      // 必須チェック
      if (
        this.form.keyword === "" &&
        this.form.catMidClassCd === "" &&
        this.form.catSmlClassCd === "" &&
        this.form.priceFrom === "" &&
        this.form.priceTo === ""
      ) {
        return "カテゴリ・ポイント・キーワードのいずれかをご入力ください";
      }

      let hasNumError = false;
      if (!this.isNumber(this.form.priceFrom)) {
        hasNumError = true;
        this.formErrorPriceFrom = true;
      }
      if (!this.isNumber(this.form.priceTo)) {
        hasNumError = true;
        this.formErrorPriceTo = true;
      }
      if (hasNumError) {
        return "ポイントは正数値で入力してください";
      }

      // From/Toの整合性チェック
      if (
        this.form.priceFrom !== "" &&
        this.form.priceTo !== "" &&
        Number(this.form.priceFrom) > Number(this.form.priceTo)
      ) {
        this.formErrorPriceFrom = true;
        this.formErrorPriceTo = true;
        return "ポイントの範囲指定が不正です";
      }

      return "";
    },
    /**
     * 検索ボタンクリックイベント
     */
    onSearch() {
      // 現在のポイントで探すにチェックした場合、priceFromを空に、priceToに使用可能ポイントをセットする
      if (this.form.chkCurrentPoint) {
        this.form.priceFrom = "";
        this.form.priceTo = String(this.floorIC(this.icPoints));
      }
      this.formError = this.validate();
      if (this.formError) {
        return;
      }

      const params = new URLSearchParams(this.getQueryString());

      const url =
        process.env.VUE_APP_SHOP_DOMAIN +
        "/product/list-goods?" +
        params;

      window.open(url, "_self");
    },
    /** 10の位を切り上げした数字を返す */
    ceilIC(amount) {
      // 10のくらいできりあげ
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.ceil(amount / 100) * 100;
    },
    /** 10の位を切り捨てた数字を返す */
    floorIC(amount) {
      // 10のくらいで切り捨てた切り捨て
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.floor(amount / 100) * 100;
    },
    convZenkakuNum(e) {
      if (e) {
        const hankakuNum = e.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        });
        const numStr = hankakuNum.replace(/[^0-9]/gi, "");
        if (numStr != "") {
          return String(Number(numStr));
        }
      }
      return "";
    },
    toNumFormatPriceFrom(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceFrom = numStr;
      } else {
        this.form.priceFrom = "";
      }
    },
    toNumFormatPriceTo(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceTo = numStr;
      } else {
        this.form.priceTo = "";
      }
    },
    getQueryString() {
      const query = {};
      const hasCategorySelection = this.form.catMidClassCd !== "" || this.form.catSmlClassCd !== "";

      // カテゴリ未指定時はクエリに大カテゴリを含めない
      if (hasCategorySelection && this.form.catLrgClassCd) {
        query.catLrgClassCd = this.form.catLrgClassCd;
      }

      if (this.form.catMidClassCd) {
        query.catMidClassCd = this.form.catMidClassCd;
      }

      if (this.form.catSmlClassCd) {
        query.catSmlClassCd = this.form.catSmlClassCd;
      }

      if (this.form.priceFrom) {
        if (Number(this.form.priceFrom) > POINT_MAX) {
          this.form.priceFrom = String(POINT_MAX);
        } else {
          this.form.priceFrom = String(this.ceilIC(this.form.priceFrom));
        }
        query.priceFrom = this.form.priceFrom;
      }

      if (this.form.priceTo) {
        if (Number(this.form.priceTo) > POINT_MAX) {
          this.form.priceTo = String(POINT_MAX);
        } else {
          this.form.priceTo = String(this.ceilIC(this.form.priceTo));
        }
        query.priceTo = this.form.priceTo;
      }

      if (this.form.chkCurrentPoint) {
        query.chkCurrentPoint = this.form.chkCurrentPoint;
      }

      if (this.form.checked && this.form.checked.length) {
        query.checked = this.form.checked.join(",");
      }

      if (this.form.keyword) {
        query.keyword = this.form.keyword;
      }

      return query;
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "@/assets/css/_object/_component/c-shop-search";
// @import "@/assets/css/_object/_component/c-input";

// assets/css/_object/_component/c-shop-search
.c-shop-search {
  position: relative;
  padding: 1rem;

  &__param {
    display: flex;
    margin-bottom: 1rem;

    &__label {
      height: 40px;
      line-height: 40px;
      vertical-align: middle;
      width: 120px;
    }

    .c-input {
      display: inline-block;
    }
  }

  .c-select {
    width: calc(100% / 3 - 0.5rem);
    margin-right: 0.5rem;
    vertical-align: middle;
  }

  &__unit {
    height: 40px;
    line-height: 40px;
    margin-left: 0.25rem;
    margin-right: 1rem;
    @include mq() {
      line-height: normal;
      font-size: 0.875rem;
    }
  }

  &__caution {
    line-height: 1.5;
    padding: 0 0 1rem;

    @include sp {
      font-size: 0.875rem;
    }
  }

  &__error-icon {
    vertical-align: middle;
  }

  &__error-message {
    @include sp {
      font-size: 0.875rem;
    }
  }

  &__checkbox-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  &__checkbox {
    flex-shrink: 0;
    font-size: 14px;
    width: auto;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  @include mq() {
    .c-shop-search__param {
      display: block;
    }

    &__category {
      .c-shop-search__param__label {
        display: none;
      }

      .c-select {
        margin-bottom: 0.5rem;
        width: 100%;
      }
    }

    &__price,
    &__discount-rate {
      .c-shop-search__input-wrapper {
        margin-bottom: 0.5rem;
        width: 100%;
        white-space: nowrap;
      }
      .c-input {
        display: inline-block;
        width: calc(100% - 80px);
      }
    }
  }
}

// assets/css/_object/_component/c-input
$Red: #da291c;
$CoolBlack: #1f2021;
$CoolGray3: #cacccf;
$CoolGray6: #f4f5f6;
$ErrorBg: #fae6e9;

$radiusSizeSm: 0.25rem;
$radiusSizeMd: 0.5rem;

.c-input {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  > * {
    height: 100%;
  }
  input[type="text"]:focus {
    outline: none;
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="url"],
  input[type="tel"],
  input[type="number"],
  textarea,
  select {
    padding: 0.5rem;
    width: 100%;
    border: 1px solid $CoolGray3;
    border-radius: $radiusSizeSm;
    color: $CoolBlack;
    line-height: 1.8;
    overflow: hidden;
    &::placeholder {
      color: $CoolGray3;
    }
  }

  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="url"],
  input[type="tel"],
  input[type="number"],
  textarea {
    background-color: #fff;
  }

  textarea {
    min-height: 8rem;
    resize: vertical;
  }

  .c-input__selectLabel {
    position: relative;
    z-index: 0;
    display: block;
    width: 100%;
    background-color: #fff;
    border-radius: $radiusSizeSm;
    overflow: hidden;

    select {
      position: relative;
      z-index: 2;
      padding-right: 2rem;
      background-color: transparent;
    }
  }

  .c-input__selectLabel__arrow {
    z-index: 1;
    position: absolute;
    top: 50%;
    right: 1rem;
    margin-top: -0.75rem;
    width: 1.5rem;
    height: 1.5rem;
  }

  &__searchlabel {
    font-weight: bold;
    @include mq("lg", "min") {
      display: block;
    }
    @include mq("lg") {
      display: block;
    }
    @include mq() {
      display: none;
    }
  }

  &.c-input--group {
    input[type="text"],
    input[type="password"],
    input[type="search"],
    input[type="email"],
    input[type="url"],
    input[type="tel"],
    input[type="number"] {
      padding: 0.75rem 1rem;
    }

    .c-input__text {
      &:first-child {
        height: 3rem;
        border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
        input[type="text"],
        input[type="password"],
        input[type="search"],
        input[type="email"],
        input[type="url"],
        input[type="tel"],
        input[type="number"],
        textarea,
        select {
          border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
        }
      }
      &:last-child {
        border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
        input[type="text"],
        input[type="password"],
        input[type="search"],
        input[type="email"],
        input[type="url"],
        input[type="tel"],
        input[type="number"],
        textarea,
        select {
          border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
        }
      }
    }
    .c-input__button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.75rem;
      background-color: $Red;
      color: #fff;
      height: 3rem;
      .c-icon {
        &:not(:last-child) {
          margin-right: 0.5rem;
        }
        g {
          fill: #fff;
        }
      }
      &:hover {
        color: #fff;
        cursor: pointer;
      }
      &:first-child {
        border-radius: $radiusSizeMd 0 0 $radiusSizeMd;
      }
      &:last-child {
        border-radius: 0 $radiusSizeMd $radiusSizeMd 0;
      }
      @include mq("md", "min") {
        min-width: 5em;
      }
      @include mq() {
        min-width: 3em;
      }
    }
  }

  &.c-input--transparent {
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="url"],
    input[type="tel"],
    input[type="number"],
    textarea {
      background-color: transparent;
      border: none;
    }
  }
  &__background {
    background: $CoolGray6 !important;
    &:focus {
      background-color: #fff7f7 !important;
      border: 1px solid $Red !important;
    }
    &--error {
      background: $ErrorBg !important;
    }
  }
}
</style>
